import React, { useEffect } from "react";
import "./styles.scss";
import { LoginForm } from "../../schoolUiComponents/loginForm";
import { useAuthSigninState } from "./../../authSignin/state";

export const TeacherAndParentLogin = ({
  isTeacher = false,
  isParent = false,
}) => {
  const { sendEvent } = useAuthSigninState();

  const teacherParentTabSwitchEvent = (page: string) => {
    trackPageViewOnGa('login-popup')
    sendEvent(`Login as ${page}`);
    window.location.hash = page;
  } 

  useEffect(() => {
    localStorage.setItem("showClassroomActivitySelection", "1");
  },[])


  return (
    <div className={`teacher-and-parent-login ${isTeacher ? 'teacher' : 'parent'}`} data-test-id="parent-and-teacher-login">
      <button className="login-back dark" onClick={() => window.location.hash = ""} aria-label="Go back"><i className="iconcust-iconBackBtn"></i></button>
      <h4>Log In as</h4>
      <div className="tab-view">
        <button
          className={`tab ${isTeacher ? "active" : ""}`}
          onClick={() => { teacherParentTabSwitchEvent("#teacher")}}
          data-test-id="teacher-tab"
          type="button"
          aria-label="Switch to teacher login"
          aria-pressed={isTeacher}
        >
          Teacher
        </button>
        <button
          className={`tab ${isParent ? "active" : ""}`}
          onClick={() => {teacherParentTabSwitchEvent("#parent")}}
          data-test-id="parent-tab"
          type="button"
          aria-label="Switch to parent login"
          aria-pressed={isParent}
        >
          Parent
        </button>
      </div>
      <LoginForm source="Parent/Teacher Login" sendEvent={sendEvent}/>
      <div className="register-link">
        New {isParent ? "Parents" : "Teacher"}?{" "}
        <a
          href={isParent ? "/parents/register" : "/teachers/register"}
          onClick={() => sendEvent(`Register here: ${isParent ? "/parents/register" : "/teachers/register"}`)} 
        >
          Register here
        </a>
      </div>
    </div>
  );
};
